/* eslint-disable react-hooks/exhaustive-deps */
import { Search, RotateCw } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Table
} from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import Select from 'react-select'
import Loader from '../../components/atoms/Loader'
import RowEmpty from '../../components/atoms/RowEmpty'
import { BadgeStatusPrList } from '../../components/atoms/StatusLabel'
import TablePagination from '../../components/atoms/Table/TablePagination'
import ModalStockAdjustment from '../../components/modal/stockAdjustment/ModalStockAdjustment'
import api from '../../config/AxiosInstance'
import toast, { Toaster } from 'react-hot-toast'
import { convertDateWithTime } from '../../helpers/constants'
import '../../styles/style.css'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

const SelectStyles = {
  control: (base, state) => ({
    ...base,
    height: 45,
    minHeight: 45,
    borderRadius: '10px',
    borderColor: state.isFocused ? 'var(--primary-orange)' : '#e9ecef',
    boxShadow: state.isFocused ? '0 0 0 4px rgba(248, 157, 29, 0.1)' : 'none',
    backgroundColor: '#ffffff',
    border: '1px solid #e9ecef',
    fontSize: '0.9rem'
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: '45px',
    padding: '0 12px'
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px'
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#495057'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? 'var(--primary-orange)'
      : state.isFocused
        ? '#fff5e6'
        : null,
    color: state.isSelected ? 'white' : '#333',
    cursor: 'pointer'
  })
}

const FormControlStyle = {
  height: '45px',
  borderRadius: '10px',
  border: '1px solid #e9ecef',
  backgroundColor: '#ffffff',
  fontSize: '0.9rem'
}

const OPNAME_STATUSES = [
  { value: 'ongoing', label: 'Ongoing' },
  { value: 'finished', label: 'Finished' }
]

function StockOpnamePacking() {
  const { state } = useLocation()
  const navigate = useNavigate()

  const [warehouses, setWarehouses] = useState([])
  const [warehouseId, setWarehouseId] = useState(state?.warehouse_id || '')
  const [q, setQ] = useState('')
  const [debouncedQ, setDebouncedQ] = useState('')
  const [status, setStatus] = useState('')

  const [downloadBeritaAcara, setDownloadBeritaAcara] = useState({})
  const [dataItems, setDataItems] = useState({
    data: [],
    isFetch: false,
    metaData: {
      per_page: 10,
      current_page: 1,
      total_row: 0,
      total_page: 0
    }
  })
  const [selectedItem, setSelectedItem] = useState([])
  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState({
    list: false,
    item: false
  })
  const [searchItem, setSearchItem] = useState('')
  const [debouncedSearchItem, setDebouncedSearchItem] = useState('')
  const [data, setData] = useState({
    data: [],
    metadata: {
      per_page: 10,
      current_page: 1,
      total_row: 0,
      total_page: 0
    }
  })

  const refSrcWarehouses = useRef()
  const refSrcStatus = useRef()

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQ(q)
      setData((prev) => ({
        ...prev,
        metadata: { ...prev.metadata, current_page: 1 }
      }))
    }, 1000)
    return () => clearTimeout(handler)
  }, [q])

  const handlePageChange = (data) => {
    setData((prevData) => ({
      ...prevData,
      metadata: {
        ...prevData.metadata,
        current_page: data.selected + 1
      }
    }))
    window.scrollTo(0, 0)
  }

  const handleOnChangeMeta = (e) => {
    setData((prevData) => ({
      ...prevData,
      metadata: {
        ...prevData.metadata,
        per_page: parseInt(e.target.value, 10),
        current_page: 1
      }
    }))
  }

  const handlePageChangeItem = (data) => {
    setDataItems((prevData) => ({
      ...prevData,
      metaData: {
        ...prevData.metaData,
        current_page: data.selected + 1
      }
    }))
    window.scrollTo(0, 0)
  }

  const handleOnChangeMetaItem = (e) => {
    setDataItems((prevData) => ({
      ...prevData,
      metaData: {
        ...prevData.metaData,
        current_page: 1,
        per_page: parseInt(e.target.value, 10)
      }
    }))
  }

  const fetchData = async () => {
    if (!warehouseId) {
      setData((prev) => ({
        ...prev,
        data: [],
        metadata: { ...prev.metadata, total_row: 0, total_page: 0 }
      }))
      return
    }
    try {
      setLoading((prevLoading) => ({ ...prevLoading, list: true }))
      const params = {
        per_page: data.metadata.per_page,
        page: data.metadata.current_page,
        warehouse_id: warehouseId,
        q: debouncedQ,
        status: status
      }
      const res = await api.get('opname-packing', {
        params
      })
      const { data: dataResponse } = res
      if (dataResponse.success) {
        setData({
          data: dataResponse.data,
          metadata: dataResponse.metadata
        })
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: { fontSize: '14px', fontWeight: '600' }
      })
      setData((prev) => ({
        ...prev,
        data: [],
        metadata: { ...prev.metadata, total_row: 0, total_page: 0 }
      }))
    } finally {
      setLoading((prevLoading) => ({ ...prevLoading, list: false }))
    }
  }

  const fetchWarehouse = async () => {
    try {
      const params = {
        is_parent: 1,
        forUser: 1
      }
      const response = await api.get('/master/warehouses/all', { params })
      const { data } = response.data
      const options = data.map((w) => ({
        value: w.id,
        label: w.warehouse_name
      }))
      setWarehouses(options)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: { fontSize: '14px', fontWeight: '600' }
      })
    }
  }

  useEffect(() => {
    fetchData()
  }, [
    data.metadata.current_page,
    data.metadata.per_page,
    warehouseId,
    debouncedQ,
    status
  ])

  useEffect(() => {
    if (!warehouses.length) {
      fetchWarehouse()
    }
  }, [])

  const handleReset = () => {
    setQ('')
    setDebouncedQ('')
    setWarehouseId('')
    setStatus('')
    refSrcWarehouses.current?.clearValue()
    refSrcStatus.current?.clearValue()
    setData((prev) => ({
      ...prev,
      metadata: { ...prev.metadata, current_page: 1 }
    }))
  }

  const handleDownloadBeritaAcara = async (id) => {
    setDownloadBeritaAcara((prev) => ({
      ...prev,
      [id]: true
    }))
    setTimeout(() => {
      setDownloadBeritaAcara((prev) => ({
        ...prev,
        [id]: false
      }))
    }, 10000)
  }

  const columns = [
    { key: 'code', label: 'Ticket' },
    { key: 'warehouse_name', label: 'Warehouse' },
    {
      key: 'created_at',
      label: 'Created Date',
      component: (row) =>
        convertDateWithTime(row.created_at, 'DD-MM-YYYY, HH:mm')
    },
    {
      key: 'finish_date',
      label: 'Finish Date',
      component: (row) =>
        row.finish_date
          ? convertDateWithTime(row.finish_date, 'DD-MM-YYYY, HH:mm')
          : '-'
    },
    {
      key: 'status',
      label: 'Status',
      className: 'text-end',
      component: (row) => <BadgeStatusPrList text={row.status || 'done'} />
    },
    {
      key: 'download',
      label: 'Berita Acara',
      className: 'text-end',
      component: (row) => (
        <Button
          variant="transparent"
          className={`${
            row.status === 'finished' && !downloadBeritaAcara[row.id]
              ? 'btn-primary-blue'
              : 'btn-secondary opacity-25'
          }`}
          onClick={() => handleDownloadBeritaAcara(row.id)}
          disabled={row.status !== 'finished' || downloadBeritaAcara[row.id]}
          size="sm"
        >
          {downloadBeritaAcara[row.id] ? 'Downloading...' : 'Download'}
        </Button>
      )
    },
    {
      key: 'action',
      label: 'Action',
      className: 'text-end',
      component: (row) => (
        <button
          className="btn btn-light text-secondary border rounded"
          style={{ width: '32px', height: '32px', padding: 0 }}
          onClick={() => {
            navigate(`/stock-opname/packing-stock-opname/detail/${row.id}`, {
              state: {
                warehouse_id: warehouseId,
                q: q,
                status: status
              }
            })
          }}
        >
          <Search size={14} />
        </button>
      )
    }
  ]

  const columnAddItems = [
    { key: 'checkbox', label: 'checkbox' },
    { key: 'item_name', label: 'Item' },
    {
      key: 'total_pack',
      label: 'Total Pack',
      className: 'text-end align-middle'
    }
  ]

  const handleSearch = (value) => {
    setSearchItem(value)
  }

  const handleChangeCheckbox = (id) => {
    if (!id) {
      if (
        !selectedItem.length ||
        selectedItem.length !== dataItems.data.length
      ) {
        setSelectedItem(dataItems.data)
      } else {
        setSelectedItem([])
      }
    } else {
      const dataSelectedItem = dataItems.data.find(
        (item) => item.item_id === id
      )
      setSelectedItem((prevSelectedItem) => {
        if (prevSelectedItem.find((item) => item.item_id === id)) {
          return prevSelectedItem.filter((item) => item.item_id !== id)
        } else {
          return [...prevSelectedItem, dataSelectedItem]
        }
      })
    }
  }

  const handleSubmitAddItem = async () => {
    navigate('/stock-opname/packing-stock-opname/create', {
      state: {
        warehouse_id: warehouseId,
        warehouse_name:
          warehouses.find((w) => w.value === warehouseId)?.label || '',
        selectedItems: selectedItem
      }
    })
  }

  const getDataItems = async () => {
    try {
      setLoading((prevLoading) => ({ ...prevLoading, item: true }))
      const params = {
        warehouse_id: warehouseId,
        per_page: dataItems.metaData.per_page || 10,
        page: dataItems.metaData.current_page || 1,
        q: debouncedSearchItem || ''
      }
      const response = await api.get('/opname-packing/items', { params })
      const { data, metadata } = response.data
      setDataItems((prevDataItems) => ({
        ...prevDataItems,
        data,
        isFetch: true,
        metaData: metadata
      }))
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: { fontSize: '14px', fontWeight: '600' }
      })
    } finally {
      setLoading((prevLoading) => ({ ...prevLoading, item: false }))
    }
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchItem(searchItem)
      setDataItems((prev) => ({
        ...prev,
        metaData: { ...prev.metaData, current_page: 1 }
      }))
    }, 1000)
    return () => clearTimeout(handler)
  }, [searchItem])

  useEffect(() => {
    if (show) {
      getDataItems()
    }
  }, [
    show,
    debouncedSearchItem,
    dataItems.metaData.current_page,
    dataItems.metaData.per_page,
    warehouseId
  ])

  return (
    <Container fluid className="px-4">
      <Toaster />
      <Row className="mb-4 align-items-center">
        <Col>
          <h3 style={headerTitleStyle}>Packing Stock Opname</h3>
        </Col>
        <Col className="text-end d-flex justify-content-end gap-2">
          <Button
            variant="light"
            className="text-secondary fw-bold rounded px-3 border"
            onClick={handleReset}
            style={{ fontSize: '0.85rem' }}
          >
            <RotateCw size={16} className="me-2" />
            Reset Filters
          </Button>
          <Button
            variant="transparent"
            className={`fw-bold rounded px-4 ${
              !warehouseId ? 'btn-secondary opacity-25' : 'btn-primary-orange'
            }`}
            onClick={() => setShow(true)}
            disabled={!warehouseId}
            style={{ fontSize: '0.85rem' }}
          >
            Create
          </Button>
        </Col>
      </Row>

      <Card style={cardFilterStyle}>
        <Row className="g-3">
          <Col md={4}>
            <Form.Group>
              <Form.Label style={labelStyle}>Ticket</Form.Label>
              <InputGroup>
                <InputGroup.Text
                  style={{
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #e9ecef',
                    borderRight: 'none',
                    borderTopLeftRadius: '10px',
                    borderBottomLeftRadius: '10px'
                  }}
                >
                  <Search size={14} className="text-muted" />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Search Ticket"
                  style={{
                    ...FormControlStyle,
                    borderLeft: 'none',
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0
                  }}
                  onChange={(e) => {
                    setQ(e.target.value)
                  }}
                  value={q}
                />
              </InputGroup>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label style={labelStyle}>Warehouse</Form.Label>
              <Select
                isClearable
                ref={refSrcWarehouses}
                options={warehouses}
                styles={SelectStyles}
                placeholder="All Warehouses"
                onChange={(e) => {
                  setWarehouseId(e?.value || '')
                  setData((prev) => ({
                    ...prev,
                    metadata: { ...prev.metadata, current_page: 1 }
                  }))
                }}
                value={
                  warehouseId
                    ? warehouses.find((w) => w.value === warehouseId)
                    : null
                }
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label style={labelStyle}>Status</Form.Label>
              <Select
                isClearable
                ref={refSrcStatus}
                options={OPNAME_STATUSES}
                styles={SelectStyles}
                placeholder="All Statuses"
                onChange={(e) => {
                  setStatus(e?.value || '')
                  setData((prev) => ({
                    ...prev,
                    metadata: { ...prev.metadata, current_page: 1 }
                  }))
                }}
                value={
                  status
                    ? OPNAME_STATUSES.find((s) => s.value === status)
                    : null
                }
              />
            </Form.Group>
          </Col>
        </Row>
      </Card>

      <Row>
        <Col md={12}>
          <Table
            hover
            responsive
            className="shadow-sm mb-5 bg-white"
            style={{
              borderRadius: '12px',
              overflow: 'hidden',
              fontSize: '0.9rem'
            }}
          >
            <thead>
              <tr>
                {columns.map((column) => (
                  <th
                    className={`p-2 align-middle ${column.className || ''}`}
                    key={column.key}
                    style={tableHeaderStyle}
                  >
                    <span>{column.label}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading.list && (
                <tr>
                  <td colSpan={columns.length} className="text-center p-5">
                    <Loader />
                  </td>
                </tr>
              )}
              {!loading.list && data.data.length === 0 && (
                <RowEmpty colSpan={columns.length} />
              )}
              {!loading.list &&
                data.data.length > 0 &&
                data.data.map((item) => (
                  <tr key={item.id}>
                    <td className="p-2 align-middle fw-bold">
                      {item.code || '-'}
                    </td>
                    <td className="p-2 align-middle">{item.warehouse_name}</td>
                    <td className="p-2 align-middle">
                      {convertDateWithTime(
                        item.created_at,
                        'DD-MM-YYYY, HH:mm'
                      )}
                    </td>
                    <td className="p-2 align-middle">
                      {item.finish_date
                        ? convertDateWithTime(
                            item.finish_date,
                            'DD-MM-YYYY, HH:mm'
                          )
                        : '-'}
                    </td>
                    <td className="p-2 align-middle text-end">
                      <BadgeStatusPrList text={item.status || 'done'} />
                    </td>
                    <td className="p-2 align-middle text-end">
                      <Button
                        variant="transparent"
                        className={`${
                          item.status === 'finished' &&
                          !downloadBeritaAcara[item.id]
                            ? 'btn-primary-blue'
                            : 'btn-secondary opacity-25'
                        }`}
                        onClick={() => handleDownloadBeritaAcara(item.id)}
                        disabled={
                          item.status !== 'finished' ||
                          downloadBeritaAcara[item.id]
                        }
                        size="sm"
                      >
                        {downloadBeritaAcara[item.id]
                          ? 'Downloading...'
                          : 'Download'}
                      </Button>
                    </td>
                    <td className="p-2 align-middle text-end">
                      <button
                        className="btn btn-light text-secondary border rounded"
                        style={{ width: '32px', height: '32px', padding: 0 }}
                        onClick={() => {
                          navigate(
                            `/stock-opname/packing-stock-opname/detail/${item.id}`,
                            {
                              state: {
                                warehouse_id: warehouseId,
                                q: q,
                                status: status
                              }
                            }
                          )
                        }}
                      >
                        <Search size={14} />
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={columns.length} className="p-3 border-top-0">
                  <TablePagination
                    meta={data.metadata}
                    handleOnChangeMeta={handleOnChangeMeta}
                    handlePageChange={handlePageChange}
                  />
                </td>
              </tr>
            </tfoot>
          </Table>
        </Col>
      </Row>

      <ModalStockAdjustment
        show={show}
        onHide={() => {
          setShow(false)
          setSelectedItem([])
        }}
        title="Select Item"
        size="xl"
        backdrop="static"
      >
        <Row className="mt-3" style={{ overflowY: 'auto', maxHeight: '70vh' }}>
          <div className="d-flex flex-row gap-2 my-2 justify-content-end align-items-center">
            <InputGroup style={{ width: '40%' }}>
              <InputGroup.Text
                style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #e9ecef',
                  borderRight: 'none',
                  borderTopLeftRadius: '10px',
                  borderBottomLeftRadius: '10px'
                }}
              >
                <Search size={14} className="text-muted" />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search Item"
                style={{
                  height: '40px',
                  borderLeft: 'none',
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                  borderTopRightRadius: '10px',
                  borderBottomRightRadius: '10px'
                }}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </InputGroup>
            <div>
              <Button
                className={`fw-bold rounded px-4 ${
                  selectedItem.length > 0
                    ? 'btn-primary-orange'
                    : 'btn-secondary opacity-25'
                }`}
                disabled={!selectedItem.length}
                onClick={handleSubmitAddItem}
                style={{ height: '40px' }}
              >
                Submit
              </Button>
            </div>
          </div>
          <Table
            responsive
            hover
            className="shadow-sm mb-5 bg-white rounded"
            size="sm"
            style={{
              fontSize: '14px',
              borderRadius: '12px',
              overflow: 'hidden'
            }}
          >
            <thead className="table-secondary">
              <tr>
                {columnAddItems.map((columnAddItem) => (
                  <th
                    className={`align-middle p-2 ${
                      columnAddItem.className || ''
                    }`}
                    key={columnAddItem.key}
                  >
                    {columnAddItem.key === 'checkbox' && (
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={
                          dataItems.data?.length !== 0 &&
                          dataItems.data.length === selectedItem.length
                        }
                        disabled={!dataItems.data?.length}
                        onChange={() => handleChangeCheckbox()}
                        role="button"
                      />
                    )}
                    {columnAddItem.key !== 'checkbox' && (
                      <span>{columnAddItem.label}</span>
                    )}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {(loading.item || !dataItems.isFetch) && (
                <tr>
                  <td
                    colSpan={columnAddItems.length}
                    className="p-2 text-center"
                  >
                    <Loader />
                  </td>
                </tr>
              )}
              {!loading.item &&
                !dataItems.data?.length &&
                dataItems.isFetch && (
                  <RowEmpty colSpan={columnAddItems.length} />
                )}
              {!loading.item &&
                dataItems.data?.length > 0 &&
                dataItems.isFetch &&
                dataItems.data?.map((item, index) => (
                  <tr key={index}>
                    {columnAddItems.map((column) => (
                      <td
                        key={column.key}
                        className={`align-middle p-2 ${column.className || ''}`}
                      >
                        {column.key === 'checkbox' && (
                          <input
                            type="checkbox"
                            className="form-check-input"
                            value={item?.item_id}
                            checked={selectedItem.some(
                              (itemSelected) =>
                                itemSelected.item_id === item.item_id
                            )}
                            onChange={() => handleChangeCheckbox(item?.item_id)}
                            role="button"
                          />
                        )}
                        {column.key === 'item_name' && (item.item_name ?? '-')}
                        {column.key === 'total_pack' &&
                          (item.total_pack ?? '-')}
                      </td>
                    ))}
                  </tr>
                ))}
            </tbody>
            <tfoot>
              <tr>
                <td
                  className="p-3 border-top-0"
                  colSpan={columnAddItems.length}
                >
                  <TablePagination
                    meta={dataItems?.metaData}
                    handlePageChange={handlePageChangeItem}
                    handleOnChangeMeta={handleOnChangeMetaItem}
                  />
                </td>
              </tr>
            </tfoot>
          </Table>
        </Row>
      </ModalStockAdjustment>
    </Container>
  )
}

export default StockOpnamePacking
